export default __webpack_public_path__ + "static/media/sweden-flag-icon.11665ada.svg";